import './Kbd.css';
import { t } from '../copy/strings';

/** Atalhos do catálogo de microcopy (§3.8 `Kbd`): `search` ("⌘K" ou "Ctrl K", conforme a plataforma) e `esc`. */
export type KbdKeys = 'search' | 'esc';
export type KbdPlatform = 'mac' | 'other';

export interface KbdProps {
  keys: KbdKeys;
  /** Força a plataforma (catálogo e testes); sem ela, `detectPlatform()`. */
  platform?: KbdPlatform;
  /** `true` quando o botão pai já anuncia o atalho por `aria-keyshortcuts` (§5.8). */
  ariaHidden?: boolean;
}

type NavigatorWithUAData = Navigator & { userAgentData?: { platform?: string } };

/** macOS/iOS por `navigator.userAgentData?.platform ?? navigator.platform` (§3.8); o resto é "other". */
export function detectPlatform(): KbdPlatform {
  if (typeof navigator === 'undefined') return 'other';
  const nav = navigator as NavigatorWithUAData;
  const platform = nav.userAgentData?.platform || nav.platform || '';
  return /mac|iphone|ipad|ipod|ios/i.test(platform) ? 'mac' : 'other';
}

function text(keys: KbdKeys, platform: KbdPlatform): string {
  if (keys === 'esc') return t('kbd.esc');
  return platform === 'mac' ? t('kbd.search.mac') : t('kbd.search.other');
}

/** Tecla (§3.8 `Kbd`). Some em `pointer: coarse`, no `flow`, no `topbar` ≤ 1520 e na TV (`.tv-hide`). */
export function Kbd({ keys, platform, ariaHidden = false }: KbdProps) {
  return (
    <kbd class="kbd tv-hide" data-testid="kbd" aria-hidden={ariaHidden ? 'true' : undefined}>
      {text(keys, platform ?? detectPlatform())}
    </kbd>
  );
}
